/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Order type as persisted by the canonical orders table and returned on the public order API.  Wire spellings match the approved lowercase/snake-case order contract.
 */
export enum OrderResponseType {

    Market = 'market',

    Limit = 'limit',

    Stop = 'stop',

    StopLimit = 'stop_limit',

    StopMarket = 'stop_market',

    StopLoss = 'stop_loss',

    StopLossLimit = 'stop_loss_limit',

    TakeProfit = 'take_profit',

    TakeProfitLimit = 'take_profit_limit'
}
